import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, FileHeart, Landmark, Scale } from 'lucide-react';
const services = [{
  icon: <ShieldAlert className="w-6 h-6 text-blue-600" data-id="element-123" />,
  title: 'Військова служба',
  description: 'СЗЧ, дезертирство, ухилення від служби. Питання мобілізації, отримання відстрочки та виїзд за кордон на законних підставах.',
  color: 'bg-blue-50'
}, {
  icon: <FileHeart className="w-6 h-6 text-rose-600" data-id="element-124" />,
  title: 'Медичні питання (ВЛК)',
  description: 'Оскарження висновків військово-лікарської комісії та незаконних медичних висновків. Супровід під час оглядів.',
  color: 'bg-rose-50'
}, {
  icon: <Landmark className="w-6 h-6 text-emerald-600" data-id="element-125" />,
  title: 'Виплати та компенсації',
  description: "Забезпечення виплат після поранення, у разі загибелі, у зв'язку з інвалідністю. Отримання одноразової грошової допомоги.",
  color: 'bg-emerald-50'
}, {
  icon: <Scale className="w-6 h-6 text-purple-600" data-id="element-126" />,
  title: 'Судовий захист',
  description: 'Представництво в суді. Захист у справах за ст. 130 КУпАП. Взаємодія з ТЦК та СП, військовими частинами.',
  color: 'bg-purple-50'
}];
export function Services() {
  return <section id="services" className="py-24 bg-slate-50" data-id="element-127">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-4" data-id="element-130">
            Напрямки нашої роботи
          </h2>
          <p className="text-lg text-slate-500" data-id="element-131">
            Ми спеціалізуємося на питаннях, які сьогодні найбільше хвилюють
            військовослужбовців, водіїв та їхні родини.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-132">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '0px 0px -50px 0px'
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-slate-100" data-id="element-133">
              <div className={`w-14 h-14 rounded-2xl ${service.color} flex items-center justify-center mb-6`} data-id="element-134">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-135">
                {service.title}
              </h3>
              <p className="text-slate-500 leading-relaxed" data-id="element-136">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}